module.exports = __webpack_public_path__ + "static/media/home.0742f73a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/navbar/home.svg
// module id = 2240
// module chunks = 0